<template>
    <div class="part4" id="part4" ref="part4">
        <div class="part4_bd">
            <div class="part_section" id="section2"></div>
            <div class="css_left_routeItinerarie" :class="{'css_left_absolute': !isLeftFixed, 'css_left_fixed': isLeftFixed}"
            :style="leftMenuPosition">
                <!---由于该标题字数不统一 需要手动在需要折行得地方加<br/>--->
                <div class="blur_bd_title">行程<br>详情</div>
                <!-- <div class="bd_title">可选付<br/>费服务</div> -->
                <div class="bd_fix_nav">
                    <a class="over_view cursor-pointer" style="cursor:pointer;" @click="showRoutePopup">概览</a>
                    <ul>
                        <li v-for="(port, i) in ports" :key="('port_overview_'+i)" :class="{'cur': currentRouteIndex == i}"
                        @click="onLeftMenuClick(i)">
                            <a>第{{port.day}}天</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="part4_bd_main">
                <ul>
                    <li v-for="(port, i) in ports" :key="('ports_'+i)">
                        <div class="list_box routeItineraries" :ref="('routeItineraries_'+i)">
                            <div class="list_hd">
                                <span class="day_title">D{{port.day}}</span>
                                {{getTitle(port)}}
                            </div>

                            <div class="list_bd" v-if="i%2==0">
                                <div class="list_text">
                                    <div class="list_text_box">
                                        <dl>
                                            <dt>{{getDescriptionTitle(port, i)}}</dt>
                                            <dd v-html="getDescription(port)">
                                            </dd>
                                            <dd>
                                                <a class="pop-modal" v-if="i!=0&&i!=ports.length-1&&port.code.indexOf('CRU')<0&&showRow == false"
                                                @click="showShorexPopup(port)"
                                                >
                                                    岸上观光服务
                                                </a>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <div class="list_img">
                                    <BannerKV 
                                        :banners="getPortImages(port)"
                                    />
                                </div>
                            </div>
                            <div class="list_bd" v-else>
                                <div class="list_img">
                                    <BannerKV 
                                        :banners="getPortImages(port)"
                                    />
                                </div>
                                <div class="list_text">
                                    <div class="list_text_box">
                                        <dl>
                                            <dt>{{getDescriptionTitle(port, i)}}</dt>
                                            <dd v-html="getDescription(port)">
                                            </dd>
                                            <dd v-if="i!=0&&i!=ports.length-1&&port.code.indexOf('CRU')<0&&showRow == false">
                                                <a class="pop-modal" @click="showShorexPopup(port)">
                                                    岸上观光服务
                                                </a>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </div>

                            <div class="list_border">
                                <i class="detail_ico_40 title_logo"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <CruiseDetailRoutePopup 
            :ports="ports"
            :sailDate="sailDate"
            :isShow="isShowRoutePopup"
            v-on:onModalClose="closeRoutePopup"
        />

        <CruiseDetailShorexPopup 
            :isShow="isShowShorexPopup"
            v-on:onModalClose="closeShorexPopup"
            :shorexInfo="shorexInfo"
        />

    </div>
</template>

<script>
const BannerKV = () => import('@/components/BannerKV.vue')
const CruiseDetailRoutePopup = () => import('@/components/Cruise/CruiseDetail/CruiseDetailRoutePopup.vue')
const CruiseDetailShorexPopup = () => import('@/components/Cruise/CruiseDetail/CruiseDetailShorexPopup.vue')

import api from '@/api'
export default {
    name: "CruiseDetailRoute",
    components: {
        BannerKV,
        CruiseDetailRoutePopup,
        CruiseDetailShorexPopup
    },
    props: {
        ports: {
            type: Array
        },
        shipCode: {
            type: String
        },
        sailDate: {
            type: String
        },
        payShorexOnly: {
          type: Boolean,
          default: false
        },
        showRow: {
            type: Boolean,
            default: false,
        },
       
    },
    data () {
        return {
            isLeftFixed: false,
            currentRouteIndex: 0,
            isShowRoutePopup: false,
            isShowShorexPopup: false,
            shorexInfo: {},
            leftMenuPosition: {}
        }
    },
    beforeMount () {
        const self = this
        window.addEventListener('scroll', () => {
            self.leftMenuScrollHandler(window.scrollY)
            self.routeEventHandler(window.scrollY)
        })
        window.addEventListener('resize', this.calLeftMenuPos)
        this.calLeftMenuPos()
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.leftMenuScrollHandler)
        window.removeEventListener('scroll', this.routeEventHandler)
        window.removeEventListener('resize', this.calLeftMenuPos)
    },
    methods: {
        calLeftMenuPos () {
            const part4 = this.$refs.part4
            let left = 0
            if (part4) {
                left = this.$refs.part4.offsetLeft
            }
            this.leftMenuPosition = this.isLeftFixed ? { 'left': left + 'px'} : { 'left': '0px'}
        },
        getTitle (routeEvent) {
            const code = routeEvent.code
            const portDay = routeEvent.portDay
            if (code && code.indexOf("CRU") >= 0) {
                return portDay + "  海上巡航"
            }
            let title = portDay + "  " + routeEvent.countryName
            if (routeEvent.activity == "EMBARK" || routeEvent.activity == "DEBARK") {
              title += ("·" + routeEvent.harborCNName)
            } else {
                title += "·" + routeEvent.name
            }
            let arrivalTime = routeEvent.arrivalTime
            if (arrivalTime && arrivalTime.length > 0) {
                if (arrivalTime.length > 5) {
                    arrivalTime = arrivalTime.substring(0, 5)
                }
                title += "  抵港 " + arrivalTime
            }

            let departureTime = routeEvent.departureTime
            if (departureTime && departureTime.length > 0) {
                if (departureTime.length > 5) {
                    departureTime = departureTime.substring(0, 5)
                }
                title += "  起航 " + departureTime
            }

            return title

        },
        getDescriptionTitle (routeEvent, i) {
            if (i == 0) {
                return "出发港介绍"
            } else if (routeEvent.code.indexOf("CRU") < 0) {
                return "目的港介绍"
            }
            return ""
        },
        getDescription (routeEvent) {
            let description = routeEvent.description
            //let link = ""
            if (routeEvent.activity == "EMBARK" || routeEvent.activity == "DEBARK") {
                
                // if (routeEvent.activity == 'EMBARK') {
                //     description += `<p>办理登船时间: ${this.boardingTime}</p>`
                // }
                // if (routeEvent.code.indexOf('HKG') == 0) {
                //     link = "https://resource.rcclchina.com.cn/PDF/%E7%9A%87%E5%AE%B6%E9%81%8A%E8%BC%AA%E5%81%87%E6%9C%9F-%E6%B5%B7%E6%B4%8B%E5%85%89%E8%AD%9C%E8%99%9F%E9%A6%99%E6%B8%AF%E8%88%AA%E6%AC%A1%20%EF%BC%88CH%20%20EN%EF%BC%89-1.pdf"
                // }
                // else if (this.shipCode == 'SC') {
                //     link = "https://www.rcclchina.com.cn/media/default/images/Royal_Cruise_Vacation-SC.pdf"
                // } else if (this.shipCode == 'QN') {
                //     link = "https://www.rcclchina.com.cn/media/default/images/Royal_Cruise_Vacation-QN.pdf"
                // }
                // if (link.length > 0) {
                //     description += `<p>
                //         <span>您可能还需要了解：<a href='${link}' target='_blank'>行前准备和登船离船</a></span>
                //     </p>`
                // }
            }
            return description
        },
        getPortImages(routeEvent) {
            let portImages = []
            if (!routeEvent || !routeEvent.images) return portImages
            routeEvent.images.forEach(image=> {
                portImages.push({
                    image: image
                })
            })
            return portImages
        },
        leftMenuScrollHandler (scrollTop) {
            if (this.shouldLeftMenuFixed(scrollTop)) {
                this.isLeftFixed = true
            } else {
                this.isLeftFixed = false
            }
        },
        shouldLeftMenuFixed (scrollTop) {
            const part4 = this.$refs.part4
            if (part4) {
                return (part4.offsetTop+135) <= scrollTop && (part4.offsetTop+part4.offsetHeight+450 - scrollTop > window.outerHeight)
            }
            return false
        },
        routeEventHandler (scrollTop) {
            let routeTop = []
            for (let i = 0; i < this.ports.length; i++) {
                const route = this.$refs['routeItineraries_'+i]
                if (route && route[0]) {
                    routeTop.push(route[0].getBoundingClientRect().top + scrollTop + 50)
                }
            }
            if (routeTop < this.ports.length) return
            for (let i = 0; i < routeTop.length; i++) {
                const currentTop = routeTop[i];
                let preTop = 0;
                if (i > 0) {
                    preTop = routeTop[i - 1];
                }
                if (preTop < scrollTop && currentTop > scrollTop) {
                    this.currentRouteIndex = i
                    break;
                }
            }
        },
        onLeftMenuClick (i) {
            const route = this.$refs['routeItineraries_'+i]
            if (route) {
                const scroll = route[0].getBoundingClientRect().top + window.scrollY - 100
                 window.scroll({
                    top: scroll, 
                    behavior: 'smooth'
                })
            }
        },
        showRoutePopup () {
            this.isShowRoutePopup = true
        },
        closeRoutePopup () {
            this.isShowRoutePopup = false
        },
        async showShorexPopup (routeEvent) {
            this.$loading.show()
            const { success, data, errMsg } = await api.cruise.getShorexByCity({
                cityName: routeEvent.name,
                shipCode: this.shipCode,
                sailDate: this.sailDate
            })
            this.$loading.hide()
            if (!success) {
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
            }
            else {
                this.shorexInfo = {
                    freeShorex: data.freeShorex,
                    payShorex: data.payShorex,
                    payShorexOnly: this.payShorexOnly
                }
                this.isShowShorexPopup = true
            }
        },
        closeShorexPopup () {
            this.isShowShorexPopup = false
        }
    },
    computed: {
        boardingTime() {
            return '11:30-15:00'
        },
        
    },
    watch: {
        isLeftFixed () {
            this.calLeftMenuPos()
        }
    }
}
</script>

<style lang="less" scoped>
.part4 {
    border-bottom: 15px #f5f5f5 solid;
    position: relative;
    .part4_bd {
        background: #fff;
        padding: 16px 20px 20px 100px;
        position: relative;
        min-height: 500px;
    }
    .css_left_routeItinerarie {
        position: absolute;
        left: 0px;
        top: 100px;
        width: 78px;
        .blur_bd_title {
            position: absolute;
            top: 16px;
            left: -5px;
            width: 82px;
            padding: 10px 0px 20px;
            background: url(https://resource.rcclchina.com.cn/tui2/detail/part4_title_bj.png) no-repeat center;
            text-align: center;
            line-height: 78px;
            font-size: 20px;
            color: #fff;
            line-height: 1.2;
        }
        .bd_fix_nav {
            position: absolute;
            top: 100px;
            left: 0;
            border-right: 1px solid #d3dadd;
            text-align: center;
            .over_view {
                display: block;
                line-height: 40px;
                color: #006ab9;
                padding: 0 10px 0px 20px;
            }
            li {
                line-height: 40px;
                color: #747d80;
                padding: 0 10px 0px 20px;
                cursor: pointer;
                a {
                    color: black;
                    display: block;
                    &:hover{
                        text-decoration: none;
                        color: #0d72bd;
                    }
                }
            }
            li.cur {
                background: #e7f5ff;
                border-left: 3px solid #006ab9;
            }
        }
    }
    .css_left_fixed {
        position: fixed;
        top: 36px;
    }
    .css_left_absolute {
        position: absolute;
    }
    .part4_bd_main {
        .list_box {
            margin-bottom: 20px;
            position: relative;
            .route_archor {
                position: absolute;
                top: -100px;
            }
            .list_hd {
                line-height: 50px;
                font-size: 20px;
                margin-bottom: 15px;
                font-weight: 400;
                .day_title {
                    width: 50px;
                    height: 50px;
                    background: #fbc500;
                    color: #fff;
                    text-align: center;
                    display: inline-block;
                    border-radius: 50%;
                    margin: 0 13px 0 10px;
                }
            }
            .list_bd {
                background: #f5f5f5;
                margin-left: 70px;
                font-size: 0;
                width: 925px;
                .list_text {
                    width: 50%;
                    display: inline-block;
                    vertical-align: middle;
                    min-height: 200px;
                    .list_text_box {
                        padding: 30px;
                        dl {
                            margin: 0;
                            dt {
                                font-size: 16px;
                                color: #282b2c;
                                font-weight: normal;
                            }
                            dd {
                                color: #747d80;
                                border-left: 1px solid #d3dadd;
                                padding: 0px 0 10px 0px;
                                margin: 2px 0 2px 0px;
                                min-height: 50px;
                                font-size: 14px;
                                a{
                                    cursor: pointer;
                                }
                            }
                        }
                        dl:last-child dd {
                            border: none;
                        }
                        
                    }
                }
                .list_img {
                    width: 50%;
                    display: inline-block;
                    vertical-align: middle;
                    img {
                        width: 100%;
                    }
                }
            }
            .list_border {
                width: 100%;
                text-align: center;
                border-bottom: 1px solid #d3dadd;
                margin: 20px 0px 30px;
                .detail_ico_40 {
                    background-color: #fff;
                    margin-bottom: -20px;
                }
            }
        }
    }
}

</style>